import { Link } from "react-router-dom";
import { Crown, Instagram, Youtube, Facebook, Linkedin, Twitter } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

const COLS = [
  { title: "Compete", links: [["Apply", "/candidates"], ["Candidates", "/candidates"], ["Delegations", "/delegations"], ["Vote", "/vote"]] },
  { title: "Experience", links: [["Watch Live", "/watch"], ["Events", "/events"], ["Impact", "/impact"], ["News", "/news"]] },
  { title: "Partner", links: [["Sponsors", "/sponsors"], ["Become a Sponsor", "/sponsors"], ["Support", "/support"], ["Press Portal", "/press"]] },
];

export default function Footer() {
  const [email, setEmail] = useState("");
  const subscribe = async (e) => {
    e.preventDefault();
    try {
      await api.post("/newsletter", { email });
      toast.success("Welcome to the movement!", { description: "You are on the list." });
      setEmail("");
    } catch {
      toast.error("Please enter a valid email");
    }
  };

  return (
    <footer className="relative mt-20 border-t border-gold/20 bg-obsidian-800" data-testid="site-footer">
      <div className="section py-14">
        <div className="grid gap-10 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <Crown className="h-7 w-7 text-gold" />
              <span className="font-serif text-lg text-amber-50">Miss United States of Africa</span>
            </div>
            <p className="mt-3 kicker">Beauty • Culture • Leadership • Unity • Impact</p>
            <p className="mt-1 font-serif text-lg gold-text">One Africa • One People • One Future</p>
            <form onSubmit={subscribe} className="mt-6 flex max-w-sm gap-2" data-testid="newsletter-form">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email"
                data-testid="newsletter-input"
                className="flex-1 rounded-full border border-gold/25 bg-obsidian px-4 py-2.5 text-sm text-amber-50 outline-none focus:border-gold"
              />
              <button data-testid="newsletter-submit" className="btn-gold px-5 py-2.5 text-xs">Join</button>
            </form>
            <div className="mt-6 flex gap-3">
              {[
                [Instagram, "https://instagram.com/MissUnitedStatesofAfrica"],
                [Youtube, "https://youtube.com/@MissUnitedStatesofAfrica"],
                [Facebook, "https://facebook.com/MissUnitedStatesofAfrica"],
                [Twitter, "https://x.com/MissUSAfrica"],
                [Linkedin, "https://linkedin.com/company/MissUnitedStatesofAfrica"],
              ].map(([Icon, href], i) => (
                <a key={i} href={href} target="_blank" rel="noopener noreferrer" aria-label="social link"
                  data-testid={`footer-social-${i}`}
                  className="rounded-full border border-gold/25 p-2 text-amber-50/60 transition-colors hover:text-gold hover:border-gold/60">
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>
          {COLS.map((col) => (
            <div key={col.title}>
              <h4 className="kicker mb-4">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map(([label, to]) => (
                  <li key={label}>
                    <Link to={to} className="text-sm text-amber-50/70 hover:text-gold">{label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-gold/15 pt-6 sm:flex-row">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} Miss United States of Africa. All content shown is <span className="text-gold">DEMO DATA</span>.
          </p>
          <div className="flex flex-wrap gap-4 text-xs text-muted-foreground">
            {["Privacy", "Terms", "Voting Rules", "Transparency"].map((l) => (
              <Link key={l} to="/about" className="hover:text-gold">{l}</Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
